/**
 * The app-wide locale for numbers and dates.
 *
 * It comes from the user's settings (set by SettingsContext), never from a
 * country baked into the code. Until settings load it is `undefined`, which
 * makes Intl use the browser's own locale.
 */

let appLocale: string | undefined;

/** Called by SettingsContext whenever the language setting changes. */
export function setAppLocale(locale: string | null | undefined): void {
  appLocale = locale || undefined;
}

/** The locale to hand to Intl / toLocaleString. `undefined` = browser default. */
export function getAppLocale(): string | undefined {
  return appLocale;
}
